import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';

import Hero from '../../static/img/class_types_page/love_how_you_feel_dance_fitness_class.webp';
import img1 from '../../static/img/class_types_page/laptop_online_dance_fitness_classes.webp';

import nia from './ClassicNia';
import m2h from './MovingToHeal';
import moveit from './MoveIt';
import freedance from './FreeDance';
import fivestages from './FiveStages';
import floorplay from './Floorplay';

import { classTypeMap } from '../../shared/Mappings';

const text = {
  sec1header: 'More Than A Workout',
  sec1header2: 'Find Your Nia Class',
  sec1sentence1: 'So much more than ‘just a workout,’ the Nia class experience offers a holistic fusion of dance, martial arts and healing arts to create an effective, fun and transformational workout for body, mind, emotions and spirit that will leave you smiling while you sweat.',
  sec1sentence2: 'Nia classes are designed for everybody and every body – at any stage of fitness and wellness. With so many classes to choose from, find YOUR Nia and unleash your individual potential to live a healthy and meaningful life!',
  sec2header: 'Find Nia Online + On-Demand',
  sec2sentence1: 'Visit Nia On Demand for dozens of on-demand online classes and wellness programs',
};

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'white',
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  hero: {
    height: 'auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: theme.spacing(8),
  },
  heroImg: {
    height: 'auto',
    width: '100%',
  },
  section: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  section2: {
    paddingTop: theme.spacing(5),
  },
  sectionContent: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  sectionImg: {
    width: '100%',
    height: 'auto',
  },
  sectionText: {
    paddingBottom: theme.spacing(2),
  },
  sectionHeader: {
    fontSize: '2em',
    letterSpacing: '5px',
    textTransform: 'uppercase',
    lineHeight: '1.4em',
  },
  section2Header: {
    marginBottom: theme.spacing(3),
    fontSize: '2em',
    letterSpacing: '5px',
    textTransform: 'uppercase',
    paddingLeft: '46px',
    lineHeight: '1.4em',
    color: '#AFBD47',
    [theme.breakpoints.down(800)]: {
      paddingLeft: '0px',
    },
  },
  section2content: {
    textAlign: 'right',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down(800)]: {
      textAlign: 'left',
    },
  },
  section2text: {
    paddingLeft: '70px',
    [theme.breakpoints.down(800)]: {
      paddingLeft: '0px',
    },
    paddingBottom: theme.spacing(5),
  },
  buttonContainer: {
    display: 'flex',
    textAlign: 'center',
  },
  button1: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down(800)]: {
      marginLeft: theme.spacing(2),
    },
  },
  button2: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down(800)]: {
      marginRight: theme.spacing(2),
    },
  },
  horizontalDivier: {
    [theme.breakpoints.down(800)]: {
      display: 'none',
    },
  },
  selectionsHeader: {
    marginTop: theme.spacing(8),
  },
  selections: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  classHeader: {
    letterSpacing: '5px',
    textTransform: 'uppercase',
    paddingBottom: theme.spacing(3),
    fontSize: '1.25rem',
  },
  classSentence: {
    paddingBottom: theme.spacing(2),
  },
  classesButton: {
    margin: theme.spacing(2),
  },
  quoteSection: {
    marginTop: theme.spacing(6),
  },
  quoteText: {
    fontSize: '1.2em',
  },
  quoteAttr: {
    textAlign: 'right',
    lineHeight: '1.8em',
    paddingTop: theme.spacing(),
  },
});

const classTypes = {
  nia,
  m2h,
  moveit,
  freedance,
  fivestages,
  floorplay,
};

const AboutClassesPage = (props) => {
  // Get trainingLevel param. Accepts any of trainingLevels. Defaults to 'classicNia'.
  const { classType } = useParams();
  // Check validity of route param and provide default
  const startingClassType = Object.keys(classTypes).includes(classType) ? classType : 'nia';

  const [currentTab, setCurrentTab] = useState(startingClassType);
  const [currentClass, setCurrentClass] = useState(classTypes[currentTab]);

  const handleClick = (e, tab) => {
    setCurrentTab(tab);
    setCurrentClass(classTypes[tab]);
  };

  const { classes } = props;
  return (
    <div className={classes.page}>
      <NavBar />
      <main className={classes.container}>
        <div className={classes.appBarSpacer} />
        <div className={classes.content}>
          <div className={classes.hero}>
            <img className={classes.heroImg} alt="People smiling while performing a low impact dance workout in one of Nia's dance fitness classes" src={Hero} />
          </div>
          <div className={classes.section}>
            <Grid container>
              <Grid item xs={12} sm={4}>
                <div className={classes.sectionContent}>
                  <Typography variant="h1" color="textSecondary" fontWeight="fontWeightLight" className={classes.sectionHeader}>{text.sec1header}</Typography>
                </div>
              </Grid>
              <hr className={classes.horizontalDivier} />
              <Grid item xs={12} sm={7}>
                <div className={classes.sectionContent}>
                  <Typography className={classes.sectionText}>{text.sec1sentence1}</Typography>
                  <Typography className={classes.sectionText}>{text.sec1sentence2}</Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={8}>
                <div className={classes.selectionsHeader}>
                  <Typography fontWeight="fontWeightLight" color="textSecondary" variant="h2" className={classes.sectionHeader}>{text.sec1header2}</Typography>
                  <hr className={classes.divider} />
                </div>
              </Grid>
              <Grid item xs={12} className={classes.selections}>
                <Button variant={currentTab === 'nia' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'nia')}>Classic Nia</Button>
                <Button variant={currentTab === 'm2h' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'm2h')}>Moving to Heal</Button>
                <Button variant={currentTab === 'moveit' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'moveit')}>Move  It</Button>
                <Button variant={currentTab === 'freedance' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'freedance')}>Freedance</Button>
                <Button variant={currentTab === '5stages' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'fivestages')}>5 Stages</Button>
                <Button variant={currentTab === 'floorplay' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'floorplay')}>Floorplay</Button>
              </Grid>
            </Grid>
          </div>

          <div className={classes.section}>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={5}>
                <img src={currentClass.img1} className={classes.sectionImg} alt={currentClass.img1Alt} />
              </Grid>
              <Grid item xs={12} sm={7}>
                <div className={classes.sectionContent}>
                  <Typography variant="h3" className={classes.classHeader}>{currentClass.name}</Typography>
                  <Typography className={classes.classSentence}>{currentClass.sentence1}</Typography>
                  <Typography className={classes.classSentence}>{currentClass.sentence2}</Typography>
                  <div className={classes.buttonContainer}>
                    <Button className={classes.classesButton} color="secondary" variant="outlined" href={'/finder/class/?class_type=' + currentClass.code}>{classTypeMap[currentTab] + ' Classes'}</Button>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <img src={currentClass.quoteImg} className={classes.sectionImg} alt={currentClass.quoteAlt} />
              </Grid>
            </Grid>
            <Grid spacing={5} container direction="row-reverse" className={classes.quoteSection}>
              <Grid item xs={12} sm={5}>
                <img src={currentClass.img2} className={classes.sectionImg} alt={currentClass.img2Alt} />
              </Grid>
              <Grid item xs={12} sm={7}>
                <div className={classes.sectionContent}>
                  <Typography fontWeight="fontWeightLight" className={classes.quoteText}>{'"' + currentClass.quoteSentence1 + '"'}</Typography>
                  <Typography fontWeight="fontWeightLight" className={classes.quoteAttr} variant="subtitle2">{'— ' + currentClass.quoteAttr}</Typography>
                </div>
              </Grid>
            </Grid>
          </div>

          <div className={classes.section2}>
            <Grid container>
              <Grid item xs={12} sm={7}>
                <img src={img1} alt="A person signing up for a Nia dance fitness class on their laptop" className={classes.sectionImg} />
              </Grid>
              <Grid item xs={12} sm={5}>
                <div className={classes.section2content}>
                  <Typography variant="h2" fontWeight="fontWeightLight" className={classes.section2Header}>{text.sec2header}</Typography>
                  <Typography className={classes.section2text}>{text.sec2sentence1}</Typography>
                  <div className={classes.buttonContainer}>
                    <Button className={classes.button1} variant="outlined" size="small" color="secondary" href="https://niaondemand.com" target="_blank">Nia On Demand Classes</Button>
                    <Button className={classes.button2} variant="outlined" size="small" color="secondary" href="https://niaondemand.com/wellness-programs" target="_blank">Nia Wellness Programs</Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <FooterSpacer />
      </main>
      <Footer />
    </div>
  );
};

AboutClassesPage.propTypes = {
  classes: PropTypes.instanceOf(PropTypes.object).isRequired,
};

export default withStyles(styles)(AboutClassesPage);
